export default {
    // Page title
    PvPTFgameTitle: "Rocket Launch Settings",
    
    // Setting area
    topicLabel: "Topic",
    inputTopic: "Please enter topic",
    questionLabel: "Question",
    inputQuestion: "Please enter question",
    addQuestion: "Add Question",
    correctAnswer: "True",
    wrongAnswer: "False",
    gameDuration: "Game Duration",
    second: "seconds",
    saveSettings: "Save Settings",
    answerMode: "Answer Mode",
    syncMode: "Synchronized Questions",
    individualMode: "Individual Progress (Auto-advance after answering)",
    errorItems:"Error Items",
    correctItems:"Correct Items",
    
    // Prompt messages
    maxQuestions: "Maximum 20 questions allowed",
    questionExists: "Question already exists",
    
    // Button text
    addQuestionButton: "Add Question",
    saveSettingsButton: "Save Settings",

    startGame: "Start Game",
    pauseGame: "Pause Game",
    resumeGame: "Resume Game",
    gameOver: "Game Over",
    leftSide: "Left Side",
    rightSide: "Right Side",
    leftWins: "Left Side Wins!",
    rightWins: "Right Side Wins!",
    tie: "It's a Tie!",
    topic: "Topic",
    
    // Game over screen strings
    win: "Winner",
    items: "",
    wrongItems: "Correct Items",
    maxCombo: "Max Combo",
    showAnswers: "A",
    gamePaused: "Game Paused",
    referenceAnswers: "Reference Answers",
    answered: "Answered",
    clearData: "Clear Data",
    answerTime: "Answer Time",
    sendSuccess: "Game data sent successfully!",
    sendCooldown: "Already sent, please wait 1 minute before operating again",
    pushSuccess: "Game successfully pushed to HiTeach!",
    pushFailed: "Push failed: {message}",
    tokenRefreshing: "Refreshing authorization, please try again later...",
    configLoadSuccess: "Game configuration loaded successfully",
    configLoadFailed: "Load failed (using example configuration)",
}